
import getLocalisation from "./Utils/getLocalisation"
import importUtils from "./Utils/importUtils"

export default function itiRegisterDual(itiWrap, options = {}) {
    var visibileInput = $(itiWrap).find(".iti-visible");
    var hiddeInput = $(itiWrap).find(".iti-hidden");

    if ($(visibileInput).length === 0) {
        console.log("Missing visibile iti");
        return null;
    }

    // Preset visibile value in restore
    var initValue = $(hiddeInput).val();
    if (initValue) {
        $(visibileInput).val(initValue);
    }

    // Preset error class in restore
    $(visibileInput).toggleClass("is-invalid", $(hiddeInput).hasClass("is-invalid"));

    // Try preset init country
    var isValidInitCountry = false;
    var initCountry = ("" + $(visibileInput).data("initCountry")).toLowerCase();
    var itiCountries = window.intlTelInput.getCountryData();

    if (initCountry) {
        $.each(itiCountries, function (i, el) {
            if (el.iso2 === initCountry) {
                isValidInitCountry = true;
                return false; // simile al break
            }
        });
    }

    //var isValidInitCountry = initCountry && window.intlTelInput.getCountryData().some(el => el.iso2 === initCountry);

    if (!isValidInitCountry) {
        console.log("Invalid init country:" + initCountry);
        initCountry = "it";
    }

    var defaultOptions = {
        i18n: getLocalisation(),
        initialCountry: initCountry,
        nationalMode: true,
        separateDialCode: true,
        autoPlaceholder: "off",
        formatOnDisplay: false,
        formatAsYouType: false,
        countrySearch: true,
        useFullscreenPopup: false,
        loadUtils: importUtils
    }

    var iti = window.intlTelInput(visibileInput[0], $.extend({}, defaultOptions, options));

    function storeUserInput() {
        console.log("Is valid:" + iti.isValidNumber());
        var digit = iti.getNumber();

        digit = ("" + digit).trim().replace(/\s+/, "");
        if (digit === "" || digit === "+") {
            digit = "";
            $(visibileInput).val("");// Reset also the visibile field
        }
        $(hiddeInput).val(digit);
    }

    $(visibileInput).on("input", function () {
        storeUserInput();
    });

    $(visibileInput).on("countrychange", function () {
        storeUserInput();
    });

    $(visibileInput).closest("form").on("submit", function () {
        storeUserInput();
    });

    return iti;
}


